<template>
    <div>
        <!-- <div class="banner_home">
            <img src="../../../../assets/img/mainPage/banner_home.png" />
        </div> -->
        <el-carousel :interval="5000" arrow="hover" indicator-position="none" style="width: 100%;" :height="height">
            <el-carousel-item v-for="item in imgList" :key="item">
                <img :src="item" alt="bannner图" />
            </el-carousel-item>
        </el-carousel>
        <div class="product">
            <h1>深入行业与场景，加速企业数智化转型</h1>
            <el-row class="product-list">
                <el-col :span="8" v-for="(item,index) in productList" :key="index">
                    <div class="product-item"
                        :style="{background:'url('+require('../../../../assets/img/mainPage/product/'+item.bg+'_bg.png')+')',backgroundSize:'cover'}">
                        <div class="name">{{ item.name }}</div>
                        <div class="content">{{ item.content }}</div>
                        <div class="arrow" @click="jumpPage('/product/'+(index+1))">→</div>
                    </div>
                </el-col>
            </el-row>
        </div>
        <div class="companyinfo">
            <div class="bg">
                <h2>走进锦威</h2>
                <h3>高科技智慧能效服务商</h3>
                <el-row>
                    <el-col :span="12">
                        <img src="../../../../assets/img/mainPage/company_info.png"></img>
                    </el-col>
                    <el-col :span="12">
                        <h1>西安锦威电子科技有限公司</h1>
                        <p>西安锦威电子科技有限公司可提供工业机器人系统集成、厂务设备监测与控制系统(FMCS)、园区及企业数字化系统、节能减排与能源管理系统（EMS）、建筑智能化系统、机电安装系统等多种业务的设计、施工、软件开发、系统集成之全过程解决方案。
                        </p>
                        <p>西安锦威从智能化系统集成商起步，拥有建筑机电安装工程专业承包一级、电子与智能化专业承包一级、消防设施工程专业承包二级、装修工程专业承包二级、照明专业承包二级、电子与智能化设计乙级资质，是西门子数字化工业集团高级系统集成商、西门子基础设施集团西北区渠道商、施耐德配电和数字化业务服务商。<a style="color:lightseagreen" @click="jumpPage('/aboutus')">更多>></a>
                        </p>
                        <el-row>
                            <el-col :span="8" class="num-container">
                                <span class="num">2000</span>万<br>
                                公司注资2000万
                            </el-col>
                            <el-col :span="8" class="num-container">
                                <span class="num">2011</span>年<br>
                                公司成立于2011年
                            </el-col>
                            <el-col :span="8" class="num-container">
                                <span class="num">6</span>体系<br>
                                6大产品体系
                            </el-col>
                        </el-row>
                    </el-col>
                </el-row>
            </div>
        </div>
        <div class="anli">
            <h1>项目案例</h1>
            <el-menu :default-active="anliCurrentIndex.toString()" class="nav clearfix" mode="horizontal" @select="anliSelect">
                <el-menu-item :index="index.toString()" class="cursor-pointer menu-item-active"
                    v-for="(item,index) in anliMenuList" :key="index">{{item.name}}</el-menu-item>
                <el-menu-item class="cursor-pointer menu-item-active" style="font-size: 16px;" @click="jumpPage('/case')">更多>></el-menu-item>
            </el-menu>
            <div class="anli-container">
                <h2>{{ anliCurrent.name }}</h2>
                <el-row class="item" v-for="(item,index) in anliCurrent.itemList" :key="index">
                    <el-col class="item-name" :span="4">{{ item.name }}</el-col>
                    <el-col class="item-content" :span="20">{{item.content}}</el-col>
                </el-row>
                <div class="num-container">
                    <div class="num-content" v-for="(item,index) in anliCurrent.numList">
                        <span class="num">{{item.num}}</span>{{item.unit}}
                        <br>{{item.content}}
                    </div>
                </div>
                <el-button type="success" @click="jumpPage('/case/'+(+anliCurrentIndex+1))">了解详情<span>→</span></el-button>
            </div>
        </div>
        <div class="news">
            <div class="container">
                <h2>企业动态</h2>
                <hr></hr>
                <h5>关注公司动态，获取更多精准行业资讯</h5>
            </div>
            <news></news>
        </div>
    </div>
</template>

<script>
import { onMounted } from 'vue';
import news from './news'
export default{
    components: {
        news
    },
    data() {
        return {
            productList: [{name:'设备监控系统(FMCS)',content:'FMCS系统对企业厂务设施系统进行全面监测控制。涉及空调冷冻水、冷却水、空调机组、工艺冷冻水、工艺冷却水、压缩空气、真空系统、特殊气体、通用及工艺排风、工艺水系统、污水处理、电力监测、能量采集、照明控制等',bg:'fmcs'},
                {name:'园区及企业数字化系统',content:'以"数据驱动决策"为核心理念，深度融合前沿技术，为企业提供从基础管理到智能决策的全栈式数字化解决方案，助力园区与企业实现运营效率与管理质量的双重跃升。',bg:'digital'},
                {name:'节能减排与能源管理',content:'节能减排与能源管理可采用合同能源管理的方式。西安锦威提供从企业能耗现状分析，改进方案，项目实施，定制软件开发、节能验证等全过程的服务。',bg:'energy'},
                {name:'工业机器人系统集成',content:'西安锦威电子结合自身在工业控制、软件开发方面的技术优势，充分了解工业生产、物流、设备运维的需求，解决效率痛点，面向用户提供定制化工业机器人集成方案，提升整体生产效率。',bg:'robot'},
                {name:'机电安装',content:'为客户提供覆盖 “节能设计- 施工及调试 – 节能运行-数字化运维” 的全周期机电系统解决方案，通过各环节的精准把控，实现机电系统建设投资、运行维护费用、系统性能之间的平衡优化。',bg:'jidian'},
                {name:'建筑智能化系统',content:'西安锦威的建筑智能化项目涉及住宅、商业综合体、医院、博物馆、图书馆、工业厂房、洁净车间、生物安全实验室、物流园、酒店等。西安锦威可提供设计、施工、调试、软件集成、交付全过程交钥匙服务。',bg:'building'}
            ],
            anliMenuList:[{name:'半导体'},{name:'智能制造'},{name:'医药'}],
            anliCurrentIndex:0,
            anliList: [{
                name: '美光半导体（西安）FMCS系统', itemList: [
                    { name: '案例背景', content: '本项目旨在为美光半导体西安B5厂房及配套设施建设一套完整的全厂自动控制系统，包括设施管理控制系统（FMCS）和能源管理系统（EMS）。' }
                    , { name: '赋能过程', content: 'FMCS 负责对空调、机械、公用设施及工艺设备等进行集中监控，并集成各控制子系统，实现统一管理，保障生产环境稳定与设备高效运行。EMS 在 FMCS 基础上，进一步实现能源过程的监控、统计分析、信息管理、计划调度、稳态供应及计量器具管理等功能，为公司节能降耗提供数据支持。' }
                    , { name: '实施效益', content: '该自动控制系统的实施将进一步提升美光半导体西安工厂的运营效率与能源管理水平，巩固其作为陕西省重要外资项目及先进制造基地的竞争力。' }],numList:[{num:'23±0.1',unit:'℃',content:'控制精度（温度）'},{num:'50±1',unit:'%',content:'控制精度（湿度）'}]
            },
            {
                name: '中环低碳(凤台)新能源光伏产业基地项目', itemList: [
                    { name: '案例背景', content: '中环低碳（凤台）新能源光伏产业基地项目位于安徽省凤台县中环低碳光伏产业园区内。为积极响应国家绿色节能政策对工业企业提出的能效提升要求，本项目对原有厂务自控系统实施了全面智能化升级。' }
                    , { name: '赋能过程', content: '通过引入AI边缘计算服务器，成功构建AI智能优化控制系统，并针对制冷系统开展深入的算法调试与优化，实现了无人值守和显著节能的双重目标。' }
                    , { name: '实施效益', content: '项目完成了“FMCS+AI”双核控制系统的自主研发，具备全自动群控与AI能效优化等五大智能功能。该系统成为光伏行业内首个通过ISO50001能源管理体系认证的制冷系统，实际节能率较合同约定值高出3.35个百分点。' }],numList:[{num:'16.4',unit:'%',content:'节能率'},{num:'447万',unit:'KWH/年',content:'节约电量'}]
            },
            {
                name: '兰州血液制品生产基地项目', itemList: [
                    { name: '案例背景', content: '该项目以打造“国际领先、国内标杆”的现代化血液制品生产平台为目标，致力于建设一座集自动化、信息化与智能化于一体的综合性生产基地。' }
                    , { name: '赋能过程', content: '项目集成多项先进系统与设备，包括高架立体库、自动仓储物流系统、全自动分装及包装生产线，以及覆盖厂区的BMS、环境监控系统、能源管理系统、MES、DCS、SCADA、血浆管理系统和LIMS系统等。依托信息化赋能，实现了从血浆原料验收、制品生产、质量检验到成品出库的全链条数字化管控。' }
                    , { name: '实施效益', content: '该项目严格遵循国家网络安全三级等保要求，全面保障企业数据安全。项目投产后，将显著提升我国血液制品行业的自动化与信息化水平。' }],numList:[{num:'极严格',unit:'的',content:'气流控制'},{num:'持续运行',unit:'的',content:'高可靠系统'}]
            }],
            anliCurrent:{},
            autoSwitchCaseTimer: null, // 自动切换项目案例定时器
            autoSwitchCaseInterval: 5000, // 切换间隔（5秒）
            imgList: [
                require('../../../../assets/img/mainPage/banner_home.png'),
                require('../../../../assets/img/mainPage/banner_home2.png'),
            ],
            height:0
        }
    },
    watch:{
        anliCurrentIndex(val){
            this.anliCurrent=this.anliList[val]
        }
    },
    methods:{
        anliSelect(key){
            this.anliCurrentIndex=key
        },
        jumpPage(url) {
            this.$router.push(url)
        },
        startAutoSwitchCase(){
            if (this.anliMenuList.length <= 1) return; // 如果菜单项少于2个，不启动自动切换
            this.autoSwitchCaseTimer = setInterval(() => {
                this.anliCurrentIndex = (this.anliCurrentIndex + 1) % this.anliMenuList.length;
            }, this.autoSwitchCaseInterval);
        },
        stopAutoSwitchCase() {
            if (this.autoSwitchCaseTimer) {
                clearInterval(this.autoSwitchCaseTimer);
                this.autoSwitchCaseTimer = null;
            }
        }
    },
    created(){
        this.anliCurrent=this.anliList[this.anliCurrentIndex]

        let deviceWidth = document.documentElement.clientWidth
        this.height = deviceWidth * 685 / 1912 + 'px'
    },
    mounted(){
        // 页面加载后启动项目案例自动切换
        this.startAutoSwitchCase();
    },
    beforeDestroy() {
        // 组件销毁时清除定时器
        this.stopAutoSwitchCase();
    }
}
</script>

<style lang="less" scoped>
@import '@/assets/css/home.less';
</style>